angular.module 'zc.projects'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.incentives',
    url: '/incentives'
    views:
      'content@':
        templateUrl: '/templates/projects.incentives/list.html'
        controller: 'IncentiveListCtrl'

  .state 'admin.projects.incentives.new',
    url: '/new'
    views:
      'content@':
        templateUrl: '/templates/projects.incentives/edit.html'
        controller: 'IncentiveEditCtrl'
        resolve:
          discountTypes: (Meta) ->
            Meta.getIncentiveDiscountTypes()
          incentive: (Incentive, currentProject) ->
            incentive_type: 'coupon_code'
            discount_type: 'none'
            has_usage_limit: true
            has_member_only_limit: true
            maximum_usage: 1
          environment: (Environment) ->
            Environment.get()

  .state 'admin.projects.incentives.edit',
    url: '/{incentiveId:int}/edit'
    resolve:
      redirect: (Project, Incentive, $stateParams, $window) -> redirectNewDashboard(Project, Incentive, $stateParams, $window)
    views:
      'content@':
        templateUrl: '/templates/projects.incentives/edit.html'
        controller: 'IncentiveEditCtrl'
        resolve:
          discountTypes: (Meta) ->
            Meta.getIncentiveDiscountTypes()
          incentive: (Incentive, $stateParams) ->
            Incentive.get($stateParams.projectId, $stateParams.incentiveId)
          environment: (Environment) ->
            Environment.get()

  .state 'admin.projects.incentives.show',
    url: '/{incentiveId:int}'
    views:
      'content@':
        templateUrl: '/templates/projects.incentives/show.html'
        controller: 'IncentiveShowCtrl'
        resolve:
          currentProject: (Project, $stateParams) ->
            Project.get($stateParams.projectId)
          discountTypes: (Meta) ->
            Meta.getIncentiveDiscountTypes()
          incentive: (Incentive, $stateParams) ->
            Incentive.get($stateParams.projectId, $stateParams.incentiveId)

redirectNewDashboard = (Project, Incentive, $stateParams, $window) ->
  Project.getCurrent($stateParams.projectId) .then (project) ->
    Incentive.get($stateParams.projectId, $stateParams.incentiveId).then (incentive) ->
      hasIncentiveCoupons = incentive.coupons.length > 0
      if hasIncentiveCoupons
        $window.location.href = "#{ZC_CONFIG.AIDEAL_URL}/site/#{project.apikey}/campaigns/incentives/#{incentive.id}/edit"



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.incentives/routes.coffee